/** Default multi-floor building settings for new / reset homes. */
export const DEFAULT_FLOOR_COUNT = 5;
export const DEFAULT_ACTIVE_FLOOR = 3;
